<button
  type="button"
  class="comment-button"
  aria-label="Toggle comment window"
  i18n-aria-label
  (click)="buttonClicked.emit()">
  <img
    [src]="'assets/icons/white/Chat.svg'"
    height="24"
    width="24"
    alt=""
    [style.height.rem]="1.5"
    [style.width.rem]="1.5" />
  <div *ngIf="showNotificationDot" class="notification-dot">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="8" fill="#68C3EB" />
    </svg>
  </div>
</button>
